import React from 'react';
import ActionBanner from '../../Atoms/ActionBanner/ActionBanner';
import { testAttributes } from './Constants';
import * as customCss from './LenderCTA.module.scss';

const LenderCTA = (props) => <ActionBanner {...props} css={customCss} testIds={testAttributes} />;

export default LenderCTA;
